const BUTTON_CONFIG = {
  base: ' flex justify-center items-center text-md font-bold border-2 ',
  fullWidth: 'w-full',
  super: {
    active:
      'text-white bg-red-accent border-red-accent hover:bg-opacity-50 hover:border-opacity-0',
    disabled:
      'text-white bg-red-accent border-red-accent bg-opacity-50 border-opacity-0 ',
  },
  primary: {
    active:
      'text-white bg-gray-accent  border-gray-accent hover:bg-opacity-50 hover:border-opacity-0',
    disabled:
      'text-white bg-gray-accent  border-gray-accent bg-opacity-50 border-opacity-0 ',
  },
  secondary: {
    active:
      'text-gray-accent bg-white  border-gray-secondary hover:bg-light-gray ',
    disabled:
      'text-gray-accent bg-light-gray   text-opacity-50 border-gray-secondary',
  },
  tertiary: {
    active:
      'shadow-none text-red-accent bg-white  border-white  hover:bg-light-gray hover:border-light-gray',
    disabled:
      'shadow-none text-red-accent bg-light-gray  border-white  border-opacity-0',
  },
  plain: {
    active:
      'bg-white text-gray-accent  border-lightgray hover:bg-light-gray hover:border-gray-400 font-semibold',
    disabled: 'bg-light-gray text-gray-accent border-gray-400 font-semibold',
  },
  plainDisabled: {
    active:
      'bg-white text-gray-accent  border-light-gray hover:bg-light-gray hover:border-gray-400 font-semibold',
    disabled: 'bg-white text-light-gray border-light-gray font-semibold',
  },
  warning: {
    active:
      'text-white bg-warning border-warning hover:bg-opacity-80 hover:border-opacity-0',
    disabled:
      'text-white bg-warning border-warning bg-opacity-50 border-opacity-0',
  },
  inline: {
    active: 'text-black underline  hover:bg-light-gray  border-0 ',
    disabled: 'text-gray-500  border-0 ',
  },
  outline: {
    active:
      'bg-white text-black border-black hover:bg-gray-100 hover:border-gray-500 shadow-md',
    disabled:
      'bg-gray-100 text-gray-400 border-gray-300 cursor-not-allowed shadow-none',
  },
}

function CustomButton({
  onClickHandler,
  className = '',
  variant,
  children,
  fullWidth = false,
  disabled = false,
  size = 'px-3 py-2',
  rounded = 'md',
  ...props
}) {
  // Xác định thuộc tính chung, lựa chọn
  const baseClass = BUTTON_CONFIG.base
  const variantClass =
    BUTTON_CONFIG[variant]?.[disabled ? 'disabled' : 'active'] || ''
  const fullWidthClass = fullWidth ? BUTTON_CONFIG.fullWidth : ''
  const shadow = ['tertiary', 'inline'].includes(variant) ? '' : 'shadow-xl'

  return (
    <button
      onClick={onClickHandler}
      className={` ${baseClass} ${fullWidthClass} ${variantClass} ${size} rounded-${rounded} ${className} ${shadow}`}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  )
}
export default CustomButton
